import styled from 'styled-components'
import Mixin from 'components/common/Mixin'
import Theme from 'components/common/Theme/Theme'
import Media from 'components/common/Media'

export const Section = styled.div`
  padding: 18px 0;
`

export const LocationsWrapper = styled.div`
  position: relative;
  float: left;
  ${Mixin.responsive('width', '312px', '100%')};
  ${Mixin.responsive('height', '500px;', 'auto')};
  ${Media.desktop`
    max-height: 500px;
    overflow-y: auto;
    border: 1px solid ${Theme.colors.light_grey};
  `}
`

export const PageOptionsSection = styled(Section)`
  ${Mixin.responsive('padding', '0 0 35px 5px', '8px 0 5px 8px')}
  ${Mixin.desktopOnly()};
`

export const LocationsWrapperAlignedContent = styled(LocationsWrapper)`
  ${Media.mobile`
    border: 1px solid ${Theme.colors.light_grey};
    ${Mixin.responsive('padding', '0 20px', '0')};
  `}
  ${Media.desktop`
    ${Mixin.middle()};
  `}
`

export const ResultsSection = styled.div`
  ${Mixin.clearFix()};
`

export const MapWrapper = styled.div`
  position: relative;
  float: right;
  ${Mixin.responsive('width', 'calc(100% - 312px)', 'calc(100% + 32px)')};
  ${Mixin.responsive('height', '500px', '180px')};
  ${Media.mobile`
    left: 16px;
  `}
`

export const ResultsWrapper = styled(Section)`
  position: relative;
  float: left;
  padding-top: 20px;
  padding-bottom: 20px;
  ${Mixin.mobileOnly()}
`

export const SearchWrapper = styled.div`
  z-index: 1;
  position: absolute;
  top: 12px;
  right: ${props => props.fullscreenControl ? '60px' : '15px'};
  ${Mixin.desktopOnly()}
  display: flex;
  flex-direction: column;
  width: 400px;
`
